class getVehicleDiscount {
    constructor(el) {
        this.DOM = { el: el };
        this.days = this.DOM.el.dataset.days;
        this.published = this.DOM.el.dataset.published;

        this.initEvents();
    }

    initEvents() {
        document.addEventListener("DOMContentLoaded", () => this.getDiscount());
    }

    async getDiscount() {
        let date = new Date();
        date.setDate(date.getDate() - this.days);
        const published = new Date(JSON.parse(this.published).date);
        const difference = published.getTime() - date.getTime();
        const daydiff = Math.ceil(difference / (1000 * 3600 * 24));
        const hoursLeft = 24 - new Date().getHours();

        if (daydiff > 0 || daydiff === 0 && hoursLeft > 0) {
            const discountElement = Array.from(document.getElementsByClassName('vdp-discount'));
            const discountLabel = Array.from(document.getElementsByClassName('discout__label'));
            if (discountElement) discountElement[0].classList.remove('d-none');

            if (daydiff === 0 && discountLabel) {
                discountLabel[0].innerHTML = ('Profiteer nog ' + hoursLeft + ' uur van deze korting');
            } else {
                if (daydiff === 1) {
                    discountLabel[0].innerHTML = ('Profiteer nog ' + daydiff + ' dag van deze korting');
                } else {
                    discountLabel[0].innerHTML = ('Profiteer nog ' + daydiff + ' dagen van deze korting');
                }
            }
        }
    }
}

const viewsNode = document.querySelector("[data-get-discount]");
if (viewsNode !== null) {
    new getVehicleDiscount(viewsNode);
}
